module.exports = __webpack_public_path__ + "img/s-hd.ed81ce41.png";